function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M282.299 259.37L324.722 251.811L328.377 281.477L293.624 313.254C293.624 313.254 306.313 279.281 306.22 280.773C306.168 281.575 298.657 273.058 298.657 273.058L285.4 275.156L282.299 259.37Z",
  fill: "#BCB1A2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M294.72 257.267L324.565 251.948L328.22 281.615L293.467 313.393C293.467 313.393 306.155 279.42 306.063 280.91C306.011 281.715 298.499 273.197 298.499 273.197L296.794 273.467L294.72 257.267Z",
  fill: "#FBFBFB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M306.271 255.099L324.531 251.846L328.187 281.513L293.433 313.299C293.433 313.299 306.121 279.325 306.03 280.816C306.002 281.238 302.656 277.37 300.688 275.24L306.271 255.099Z",
  fill: "#6D492B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M318.274 252.96L324.722 251.811L328.376 281.484L293.624 313.261L323.858 281.877L318.274 252.96Z",
  fill: "#191919"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M183.592 183.131L235.623 150.687L235.916 243.927L297.615 252.238L274.629 308.213L197.742 279.609L183.592 183.131Z",
  fill: "#191919"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M230.468 162.391L188.111 167.976L94.4827 195.221L91.936 206.685H196.039L230.468 162.391Z",
  fill: "#191919"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M196.557 57.0426C200.089 57.0426 202.952 54.1798 202.952 50.6483C202.952 47.1167 200.089 44.2539 196.557 44.2539C193.026 44.2539 190.163 47.1167 190.163 50.6483C190.163 54.1798 193.026 57.0426 196.557 57.0426Z",
  fill: "#191919"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M172.143 45.8749C176.419 45.8749 179.885 42.4087 179.885 38.133C179.885 33.8573 176.419 30.3911 172.143 30.3911C167.868 30.3911 164.401 33.8573 164.401 38.133C164.401 42.4087 167.868 45.8749 172.143 45.8749Z",
  fill: "#3A3A3A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M164.565 36.2314C164.105 38.2082 164.44 40.2867 165.497 42.0191C166.555 43.7515 168.251 44.9992 170.219 45.4935C172.188 45.9877 174.272 45.6889 176.022 44.6615C177.772 43.6341 179.049 41.9602 179.577 40.0005C172.027 41.6089 167.648 39.3411 167.53 31.844C166.055 32.9104 165.004 34.4647 164.565 36.2314Z",
  fill: "#191919"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M183.347 61.8358C189.781 61.8358 194.997 56.6197 194.997 50.1854C194.997 43.7511 189.781 38.5351 183.347 38.5351C176.912 38.5351 171.696 43.7511 171.696 50.1854C171.696 56.6197 176.912 61.8358 183.347 61.8358Z",
  fill: "#F4DDBE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M191.144 40.6957C195.419 40.6957 198.886 37.2295 198.886 32.9538C198.886 28.6781 195.419 25.2119 191.144 25.2119C186.868 25.2119 183.402 28.6781 183.402 32.9538C183.402 37.2295 186.868 40.6957 191.144 40.6957Z",
  fill: "#3A3A3A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M183.838 30.1802C183.477 31.1307 183.307 32.1429 183.337 33.1592C183.368 34.1754 183.598 35.1757 184.015 36.1029C184.432 37.0302 185.027 37.8662 185.768 38.5633C186.508 39.2605 187.378 39.805 188.328 40.1658C189.279 40.5266 190.291 40.6967 191.307 40.6664C192.323 40.636 193.324 40.4058 194.251 39.9888C195.178 39.5719 196.014 38.9763 196.711 38.2363C197.409 37.4962 197.953 36.6261 198.314 35.6756C190.629 36.3905 186.542 33.6293 187.3 26.1698C185.708 27.0559 184.482 28.4765 183.838 30.1802Z",
  fill: "#191919"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M180.219 40.4526C185.285 40.4526 189.391 36.3464 189.391 31.281C189.391 26.2157 185.285 22.1094 180.219 22.1094C175.154 22.1094 171.048 26.2157 171.048 31.281C171.048 36.3464 175.154 40.4526 180.219 40.4526Z",
  fill: "#3A3A3A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M171.562 27.9963C170.698 30.2714 170.774 32.7963 171.772 35.0155C172.771 37.2347 174.61 38.9665 176.885 39.8299C179.16 40.6932 181.685 40.6174 183.904 39.6192C186.123 38.6209 187.855 36.782 188.718 34.5069C179.604 35.3629 174.779 32.0817 175.672 23.2479C173.784 24.2951 172.328 25.9774 171.562 27.9963Z",
  fill: "#191919"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M196.875 49.3061C201.151 49.3061 204.617 45.8399 204.617 41.5642C204.617 37.2885 201.151 33.8224 196.875 33.8224C192.599 33.8224 189.133 37.2885 189.133 41.5642C189.133 45.8399 192.599 49.3061 196.875 49.3061Z",
  fill: "#3A3A3A"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M189.296 39.6609C189.016 40.6571 188.939 41.6992 189.069 42.7256C189.199 43.7521 189.534 44.742 190.053 45.637C190.572 46.532 191.265 47.3138 192.092 47.9363C192.918 48.5588 193.861 49.0093 194.864 49.2613C195.868 49.5132 196.912 49.5615 197.934 49.4032C198.957 49.2449 199.937 48.8832 200.817 48.3396C201.698 47.796 202.46 47.0815 203.06 46.2382C203.659 45.3949 204.083 44.4401 204.308 43.43C196.757 45.0385 192.377 42.7706 192.261 35.2753C190.785 36.3411 189.735 37.8948 189.296 39.6609Z",
  fill: "#191919"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M196.895 54.7534C198.705 54.7534 200.173 53.2859 200.173 51.4758C200.173 49.6656 198.705 48.1982 196.895 48.1982C195.085 48.1982 193.618 49.6656 193.618 51.4758C193.618 53.2859 195.085 54.7534 196.895 54.7534Z",
  fill: "#F4DDBE"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M202.469 64.9955L170.671 67.1508L165.422 175.641L237.626 164.546L202.469 64.9955Z",
  fill: "#8C8C8C"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M202.469 64.9955C221.84 124.648 208.939 168.873 165.422 175.641L237.622 164.546L202.469 64.9955Z",
  fill: "#565656"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M279.439 44.6387L273.923 42.0027L286.636 15.3963C286.986 14.6646 287.612 14.1017 288.377 13.8316C289.141 13.5614 289.982 13.606 290.714 13.9557C291.445 14.3053 292.008 14.9313 292.279 15.696C292.549 16.4606 292.504 17.3013 292.154 18.033L279.441 44.6394L279.439 44.6387Z",
  fill: "#F4DDBE"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M274.108 38.5517L268.591 35.9157L281.305 9.30933C281.478 8.94702 281.721 8.62236 282.019 8.35387C282.318 8.08539 282.666 7.87834 283.045 7.74456C283.424 7.61079 283.825 7.55289 284.226 7.57419C284.627 7.59548 285.02 7.69556 285.382 7.86868C285.744 8.04181 286.069 8.28459 286.338 8.5832C286.606 8.8818 286.813 9.23036 286.947 9.60898C287.081 9.98759 287.138 10.3889 287.117 10.7898C287.096 11.1908 286.996 11.5837 286.823 11.946L274.109 38.5524L274.108 38.5517Z",
  fill: "#F4DDBE"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M267.355 35.325L261.838 32.689L274.552 6.08265C274.901 5.35092 275.527 4.78806 276.292 4.51789C277.057 4.24771 277.897 4.29235 278.629 4.64199C279.361 4.99164 279.924 5.61765 280.194 6.3823C280.464 7.14695 280.419 7.9876 280.07 8.71933L267.356 35.3257L267.355 35.325Z",
  fill: "#F4DDBE"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M260.371 33.6375L254.855 31.0016L267.568 4.39526C267.742 4.03294 267.984 3.70827 268.283 3.43978C268.582 3.1713 268.93 2.96425 269.309 2.83048C269.687 2.6967 270.089 2.63881 270.49 2.66011C270.891 2.6814 271.283 2.78147 271.646 2.9546C272.008 3.12772 272.333 3.37052 272.601 3.66912C272.87 3.96773 273.077 4.31628 273.211 4.6949C273.344 5.07351 273.402 5.47477 273.381 5.87577C273.36 6.27676 273.26 6.66962 273.086 7.03193L260.373 33.6383L260.371 33.6375Z",
  fill: "#F4DDBE"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M259.79 33.8302L254.025 35.867L249.079 21.8693C248.809 21.1047 248.854 20.264 249.204 19.5323C249.553 18.8005 250.179 18.2377 250.944 17.9675C251.709 17.6973 252.549 17.742 253.281 18.0916C254.013 18.4412 254.576 19.0673 254.846 19.8319L259.792 33.8296L259.79 33.8302Z",
  fill: "#F4DDBE"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M275.399 53.0956L250.083 40.9986L255.237 30.2125C256.031 28.5491 257.144 27.0583 258.514 25.8253C259.884 24.5923 261.483 23.6413 263.22 23.0265C264.958 22.4117 266.799 22.1453 268.64 22.2424C270.48 22.3395 272.284 22.7982 273.947 23.5924C277.304 25.1967 279.887 28.0692 281.127 31.5778C282.366 35.0865 282.162 38.9439 280.557 42.3015L275.399 53.0956Z",
  fill: "#F4DDBE"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M281.613 33.4292C281.179 31.3098 280.261 29.3194 278.93 27.6141C277.599 25.9088 275.891 24.5349 273.94 23.6V23.6C269.725 21.5841 265.167 21.7378 261.413 23.7608",
  stroke: "#191919",
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M247.871 45.748L273.265 57.6879L280.881 41.4928L252.437 36.0366L247.871 45.748Z",
  fill: "#BCB1A2"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M258.907 38.8192C260.883 33.3202 262.549 27.8355 259.777 25.7392",
  stroke: "#191919",
  strokeMiterlimit: 10
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M251.106 33.297L279.427 50.0782L274.662 56.9641L245.768 44.9241L251.106 33.297Z",
  fill: "#E6ECFC"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M222.274 95.232L248.077 35.4057L284.177 57.4394L249.342 113.127L222.274 95.232Z",
  fill: "#8C8C8C"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M202.674 66.2357L250.899 110.664L236.08 133.513L213.669 101.818L202.674 66.2357Z",
  fill: "#8C8C8C"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M202.714 66.2393C202.714 66.2393 216.711 119.991 250.934 110.666L236.115 133.516L213.708 101.821L202.714 66.2393Z",
  fill: "#565656"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M70.7876 117.738L80.0343 66.9202L63.816 68.1301L67.619 77.7377L54.7319 80.1432L64.118 95.3518L56.2278 100.095L70.7876 117.738Z",
  fill: "#7393FD"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M304.524 133.722L296.178 111.715L262.377 146.462L281.691 169.861L295.961 157.162L279.999 146.857L304.524 133.722Z",
  fill: "#449281"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M42.5864 156.242L44.8114 179.737L73.4754 172.619L42.5864 156.242Z",
  fill: "#98C7BD"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2101 135.641C18.5882 135.641 23.7586 130.471 23.7586 124.093C23.7586 117.715 18.5882 112.544 12.2101 112.544C5.83206 112.544 0.661621 117.715 0.661621 124.093C0.661621 130.471 5.83206 135.641 12.2101 135.641Z",
  fill: "#D66D4F"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M327.286 88.1783C333.664 88.1783 338.835 83.0078 338.835 76.6298C338.835 70.2517 333.664 65.0813 327.286 65.0813C320.908 65.0813 315.738 70.2517 315.738 76.6298C315.738 83.0078 320.908 88.1783 327.286 88.1783Z",
  fill: "#7393FD"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M88.8286 14.6696L92.4225 37.1125L155.598 26.9955L137.507 17.3503L165.499 0.324219L88.8286 14.6696Z",
  fill: "#98C7BD"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M326.92 198.298C336.118 198.298 343.574 190.842 343.574 181.644C343.574 172.446 336.118 164.989 326.92 164.989C317.722 164.989 310.266 172.446 310.266 181.644C310.266 190.842 317.722 198.298 326.92 198.298Z",
  fill: "#D66D4F"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M118.337 141.43L124.353 142.518L119.106 171.535C118.962 172.333 118.507 173.041 117.84 173.504C117.174 173.966 116.351 174.144 115.553 174C114.755 173.856 114.047 173.4 113.585 172.734C113.123 172.068 112.944 171.245 113.088 170.447L118.335 141.43L118.337 141.43Z",
  fill: "#F4DDBE"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M118.849 141.095L123.872 137.61L132.334 149.808C132.796 150.475 132.975 151.297 132.831 152.095C132.686 152.893 132.231 153.601 131.565 154.064C130.898 154.526 130.076 154.705 129.278 154.56C128.479 154.416 127.771 153.961 127.309 153.294L118.847 141.096L118.849 141.095Z",
  fill: "#F4DDBE"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M117.773 153.096L116.282 152.826L114.96 160.141L117.773 153.096Z",
  fill: "#BCB1A2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M127.859 121.957L100.246 116.953L98.1178 128.718C95.2101 146.005 100.275 153.305 107.901 154.683C109.714 155.011 111.574 154.978 113.374 154.587C115.175 154.196 116.881 153.455 118.395 152.404C119.908 151.354 121.201 150.016 122.197 148.466C123.194 146.916 123.875 145.185 124.203 143.372L127.859 121.957Z",
  fill: "#F4DDBE"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M102.036 142.603C102.337 140.941 101.233 139.351 99.5721 139.05C97.9107 138.75 96.3204 139.854 96.0198 141.515L93.9089 153.189C93.6084 154.851 94.7116 156.442 96.3729 156.742C98.0342 157.042 99.6246 155.939 99.9251 154.277L102.036 142.603Z",
  fill: "#F4DDBE"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M109.493 143.156C109.793 141.494 108.69 139.903 107.029 139.603C105.367 139.303 103.777 140.406 103.476 142.068L100.912 156.248C100.612 157.91 101.715 159.5 103.376 159.801C105.038 160.101 106.628 158.997 106.929 157.336L109.493 143.156Z",
  fill: "#F4DDBE"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M116.856 144.488C117.156 142.826 116.053 141.235 114.392 140.935C112.731 140.635 111.14 141.738 110.84 143.4L108.319 157.341C108.018 159.002 109.121 160.593 110.783 160.894C112.444 161.194 114.035 160.09 114.335 158.429L116.856 144.488Z",
  fill: "#F4DDBE"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8893 117.618L127.649 121.725L125.031 139.428L98.3184 128.233L99.8893 117.618Z",
  fill: "#BCB1A2"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M169.14 99.8143L111.567 105.374L105.743 78.4777L171.397 72.4425L169.14 99.8143Z",
  fill: "#8C8C8C"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M129.84 135.109L96.9546 133.595L97.9286 125.277L129.093 122.338L129.84 135.109Z",
  fill: "#E6ECFC"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M100.155 78.8333L95.3711 131.924L130.917 129.08L129.582 76.485L100.155 78.8333Z",
  fill: "#8C8C8C"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M184.716 113.248L196.187 65.251L173.643 66.9648L184.716 113.248Z",
  fill: "#E6ECFC"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M185.048 112.592L180.95 97.2319L180.745 72.0386L178.411 66.9024L184.122 66.1553L182.6 71.7955L187.877 94.8371L185.048 112.592Z",
  fill: "#D66D4F"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M192.989 65.4636L184.716 113.248L206.126 89.565L197.299 84.209L205.756 77.8789L198.561 65.0919L192.989 65.4636Z",
  fill: "#565656"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M175.48 66.4072L185.014 113.068L167.641 91.4683L173.7 85.3777L167.059 79.8465L171.382 66.5288L175.48 66.4072Z",
  fill: "#565656"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M130.847 111.12L124.457 95.2607L134.461 100.529L169.516 95.2607L169.14 99.8143L130.57 103.539L130.847 111.12Z",
  fill: "#565656"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M190.679 57.0284C189.319 58.4281 187.576 59.3961 185.669 59.8115C183.762 60.2269 181.775 60.0714 179.956 59.3643C178.137 58.6573 176.566 57.43 175.44 55.8357C174.314 54.2415 173.683 52.3508 173.625 50.3999L193.353 51.7546C193.02 53.7441 192.087 55.5844 190.679 57.0284Z",
  fill: "#A34F41"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M190.684 57.0248C189.09 58.6648 186.979 59.7049 184.707 59.9695C182.435 60.2342 180.141 59.7073 178.212 58.4777C177.656 58.1203 186.32 51.272 192.209 54.991C191.789 55.731 191.277 56.4145 190.684 57.0248Z",
  fill: "#D66D4F"
});

var SvgOnboarding = function SvgOnboarding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 314,
    viewBox: "0 0 344 314",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnboarding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onboarding.6c24fcca.svg";
export { ForwardRef as ReactComponent };